import React, { Fragment } from 'react';
import clsx from 'clsx';
import styles from './BoxPhoto.module.css';
import downloadIcon from '../../../images/download-icon.png';
import trashIcon from '../../../images/trash-icon.png';
import { Draggable } from 'react-beautiful-dnd';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { imgix } from '../../../lib/env';

const { imgix_domain, s3_domain_to_replace, imgix_parameters_main } = imgix;

class BoxPhoto extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      id: props.properties.id,
      studentPhoto: props.properties.attributes,
    };
  }

  deletePhoto = (e, id) => {
    e.preventDefault();
    confirmAlert({
      title: 'Confirm to submit',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.deletePhotoHandler(id),
        },
        {
          label: 'No',
          onClick: () => console.log('Canceled deletion'),
        },
      ],
    });
  };

  render() {
    const { hidePhotoIds } = this.props.properties;
    const { id, studentPhoto } = this.state;
    const dragId = 'photo-' + id;
    return (
      <Draggable key={dragId} draggableId={dragId} index={this.props.index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              opacity: snapshot.isDragging ? '0.7' : '1',
              ...provided.draggableProps.style,
            }}
          >
            <Fragment>
              <div 
                className={clsx(
                  styles.boxContent, 
                  this.props.properties.draggedPhotos.includes(id) && styles.faded,
                  snapshot.isDragging && styles.faded,
                  snapshot.isDragging && styles.beingDragged,
                  hidePhotoIds.includes(id) ? 'hide' : ''
                )}
              >
                {snapshot.isDragging && this.props.properties.draggedPhotos.length > 0 ? (
                  <div className={styles.indicator}>
                    {this.props.properties.draggedPhotos.length + 1}
                  </div>
                ) : (
                  <input 
                    type="checkbox" 
                    className={styles.checkbox} 
                    checked={this.props.properties.selectedPhotos.includes(id)} 
                    onChange={(e) => this.props.properties.handlePhotoSelect(id, e.target.checked)}
                  />
                )}
                <img
                  alt="student"
                  src={studentPhoto.url.replace(s3_domain_to_replace, imgix_domain) + imgix_parameters_main}
                  className={`${styles.studentPhoto}`}
                  id={id}
                  onClick={(e) => this.props.properties.handlePhotoSelect(id, !this.props.properties.selectedPhotos.includes(id))}
                />
                <div className={styles.boxActions}>
                  <a
                    download="image"
                    href={
                      studentPhoto.url.replace(s3_domain_to_replace, imgix_domain) + '?dl=' + studentPhoto.name
                    }
                  >
                    <img src={downloadIcon} alt="downloadicon" />
                  </a>
                </div>
              </div>
            </Fragment>
          </div>
        )}
      </Draggable>
    );
  }
}

export default BoxPhoto;



// WEBPACK FOOTER //
// ./src/components/ContentBox/BoxPhoto/BoxPhoto.js